import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { pluralization } from '@spa/shared/utils/translations';
import { RENT_TYPE } from '@spa/shared/constants/rentType';
import { PROPERTY_UNIT_TYPE, SUBUNIT_TYPES } from '@spa/shared/constants/unitTypes';
import { BED_TYPE_TRANSLATIONS, BEDROOM_TYPE_TRANSLATIONS } from '@spa/shared/constants/translations';
import { PROPERTY_FEATURES } from '@spa/shared/constants/propertyFeatures';
import { ACCOMMODATION_TYPE_CODE } from '@spa/shared/constants/accommodationType';
import { findUnit, getNumberOfBathrooms, getNumberOfBedrooms } from '@spa/shared/utils/transformers';
import { findBathroomType } from '@spa/shared/utils/unitTypes';
import { capitalizeFirstLetter } from '@spa/shared/utils/stringManipulation';
export var generateOfferTags = function generateOfferTags(_ref) {
  var rentBy = _ref.rentBy,
    bedType = _ref.bedType,
    bathroomType = _ref.bathroomType,
    numberOfBedrooms = _ref.numberOfBedrooms,
    numberOfBathrooms = _ref.numberOfBathrooms,
    hasElevator = _ref.hasElevator,
    propertyType = _ref.propertyType,
    maxGuests = _ref.maxGuests,
    area = _ref.area,
    t = _ref.t;
  var isRentByEntireProperty = rentBy === RENT_TYPE.ENTIRE_PROPERTY;
  var isRentByBed = rentBy === RENT_TYPE.BED;
  var isApartment = propertyType === PROPERTY_UNIT_TYPE.APARTMENT;
  var isStudio = propertyType === PROPERTY_UNIT_TYPE.STUDIO;
  var hasEnsuite = bathroomType === 'private_bathroom';
  var basePills = [].concat(_toConsumableArray(maxGuests ? [pluralization('{{count}} person', 'Up to {{count}} people', maxGuests, t)] : []), _toConsumableArray(area ? ["".concat(area, " ").concat(t('sqm'))] : []), _toConsumableArray((isApartment || isStudio) && hasElevator ? [t('With elevator')] : []));
  if (isRentByEntireProperty) {
    return [isStudio ? "".concat(t(capitalizeFirstLetter(propertyType))) : pluralization('{{count}} bedroom apartment', '{{count}} bedrooms apartment', numberOfBedrooms, t)].concat(_toConsumableArray(numberOfBathrooms ? [pluralization('{{count}} bathroom', '{{count}} bathrooms', numberOfBathrooms, t)] : []), _toConsumableArray(basePills));
  }
  if (hasEnsuite) {
    return [t(isRentByBed ? BED_TYPE_TRANSLATIONS[bedType] : BEDROOM_TYPE_TRANSLATIONS[bedType]), isStudio ? "".concat(t(capitalizeFirstLetter(propertyType))) : pluralization('{{count}} bedroom apartment', '{{count}} bedrooms apartment', numberOfBedrooms, t)].concat(_toConsumableArray(basePills));
  }
  return [t(isRentByBed ? BED_TYPE_TRANSLATIONS[bedType] : BEDROOM_TYPE_TRANSLATIONS[bedType]), isStudio ? "".concat(t(capitalizeFirstLetter(propertyType))) : pluralization('{{count}} bedroom apartment', '{{count}} bedrooms apartment', numberOfBedrooms, t)].concat(_toConsumableArray(numberOfBathrooms ? [pluralization('{{count}} bathroom', '{{count}} bathrooms', numberOfBathrooms, t)] : []), _toConsumableArray(basePills));
};
export var generateTitleData = function generateTitleData(offerAggregate) {
  var _offerAggregate$prope = offerAggregate.property_aggregate.property,
    _offerAggregate$prope2 = _offerAggregate$prope.lifecycle,
    rentByType = _offerAggregate$prope2.rent_by,
    features = _offerAggregate$prope2.features,
    _offerAggregate$prope3 = _offerAggregate$prope.typology,
    propertyAccommodationType = _offerAggregate$prope3.accommodation_type_code,
    propertyType = _offerAggregate$prope3.type_code,
    numberOfBedrooms = _offerAggregate$prope3.number_of_bedrooms,
    numberOfBathrooms = _offerAggregate$prope3.number_of_bathrooms,
    area = _offerAggregate$prope3.area,
    floors = _offerAggregate$prope.floors,
    _offerAggregate$accom = offerAggregate.accommodation_offer,
    maxGuests = _offerAggregate$accom.requisites.conditions.max_guests,
    _offerAggregate$accom2 = _offerAggregate$accom.property,
    unitType = _offerAggregate$accom2.unit_type,
    unitId = _offerAggregate$accom2.unit_id;
  var isResidence = propertyAccommodationType === ACCOMMODATION_TYPE_CODE.RESIDENCE;
  var _floors = _slicedToArray(floors, 1),
    units = _floors[0].units;
  var unit = findUnit(units, unitId);
  var rentBy = isResidence ? getRentByTypeFromUnitType(unitType) : rentByType;
  var common = {
    maxGuests: maxGuests,
    propertyType: propertyType,
    area: area,
    rentBy: rentBy,
    hasElevator: features === null || features === void 0 ? void 0 : features.some(function (_ref2) {
      var Code = _ref2.Code,
        Exists = _ref2.Exists;
      return Code === PROPERTY_FEATURES.ELEVATOR && Exists;
    }),
    numberOfBedrooms: getNumberOfBedrooms(floors, numberOfBedrooms),
    numberOfBathrooms: getNumberOfBathrooms(floors, numberOfBathrooms),
    bathroomType: findBathroomType(rentBy, units, unit === null || unit === void 0 ? void 0 : unit.subunits)
  };
  if (isRentByProperty(common.rentBy)) {
    return _objectSpread(_objectSpread({}, common), {}, {
      propertyAccommodationType: propertyAccommodationType,
      propertyType: propertyType
    });
  }
  if (isRentByBed(common.rentBy)) {
    return _objectSpread(_objectSpread({}, common), {}, {
      bedType: bedType(offerAggregate, common.rentBy)
    });
  }
  if (isRentByBedroom(common.rentBy)) {
    return _objectSpread(_objectSpread({}, common), {}, {
      bedType: bedType(offerAggregate, common.rentBy)
    });
  }
};
var isRentByProperty = function isRentByProperty(rentBy) {
  return rentBy === RENT_TYPE.ENTIRE_PROPERTY;
};
var isRentByBed = function isRentByBed(rentBy) {
  return rentBy === RENT_TYPE.BED;
};
var isRentByBedroom = function isRentByBedroom(rentBy) {
  return rentBy === RENT_TYPE.BEDROOM;
};
var bedType = function bedType(offerAggregate, rentBy) {
  var _offerAggregate$prope4 = _slicedToArray(offerAggregate.property_aggregate.property.floors, 1),
    units = _offerAggregate$prope4[0].units;
  var _offerAggregate$accom3 = offerAggregate.accommodation_offer.property,
    unitId = _offerAggregate$accom3.unit_id,
    subunitId = _offerAggregate$accom3.subunit_id;
  var unit = getRentingUnitOrSubunit(units, unitId, subunitId, rentBy);
  if (isRentByBed(rentBy)) {
    return unit.type_code;
  }
  if (isRentByBedroom(rentBy)) {
    var beds = unit.subunits.filter(function (subunit) {
      return isSubunitBed(subunit);
    });
    return getBedsType(beds);
  }
};
var getBedsType = function getBedsType(beds) {
  if (beds.length === 1) {
    return beds[0].type_code;
  }
  if (beds.length === 2) {
    return SUBUNIT_TYPES.TWIN_BED;
  }
  return SUBUNIT_TYPES.MULTIPLE_BED;
};
var getRentingUnitOrSubunit = function getRentingUnitOrSubunit(units, unitId, subunitId, rentBy) {
  var unit = findUnit(units, unitId);
  if (isRentByBedroom(rentBy)) {
    return unit;
  }
  if (isRentByBed(rentBy)) {
    return getSubunitFromUnitById(subunitId, unit);
  }
};
var isSubunitBed = function isSubunitBed(_ref3) {
  var subunitType = _ref3.type_code;
  return [SUBUNIT_TYPES.SINGLE_BED, SUBUNIT_TYPES.DOUBLE_BED].includes(subunitType);
};
var getSubunitFromUnitById = function getSubunitFromUnitById(id, _ref4) {
  var subunits = _ref4.subunits;
  return !subunits.length ? null : subunits.find(function (_ref5) {
    var subunitId = _ref5.id;
    return id === subunitId;
  });
};
var getRentByTypeFromUnitType = function getRentByTypeFromUnitType(unitType) {
  if (!unitType || [PROPERTY_UNIT_TYPE.APARTMENT, PROPERTY_UNIT_TYPE.STUDIO].includes(unitType)) {
    return RENT_TYPE.ENTIRE_PROPERTY;
  }
  if (unitType === PROPERTY_UNIT_TYPE.BEDROOM) {
    return RENT_TYPE.BEDROOM;
  }
  if ([PROPERTY_UNIT_TYPE.BED, SUBUNIT_TYPES.SINGLE_BED, SUBUNIT_TYPES.DOUBLE_BED].includes(unitType)) {
    return RENT_TYPE.BED;
  }
};